import { useEffect } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useUnmount } from 'ahooks';
import { message, Spin } from 'antd';

import { useLogout } from 'hooks';

export const PrivateRoute = ({ component }: { component: React.FC }) => {
  let timeout: NodeJS.Timeout;
  const queryParams = new URLSearchParams(window.location.search);
  const errorParam = queryParams.get('error');

  const [handleLogout] = useLogout();

  useUnmount(() => {
    clearTimeout(timeout);
  });

  useEffect(() => {
    if (errorParam === 'unauthorized') {
      message.error('You are not authorized for this action. You will be redirected in 3 seconds.');

      timeout = setTimeout(() => {
        handleLogout();
      }, 3000);
    }
  }, [errorParam]);

  if (errorParam === 'unauthorized') {
    return <div />;
  }

  const Component = withAuthenticationRequired(
    component,
    {
      onRedirecting: () => <Spin size='large'><div className='h-[100vh] w-[100vw]' /></Spin>,
    },
  );

  return <Component />;
};
